import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 140 140"
    {...rest}
  >
    <g
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        d="M17.5 97.3h105a13.04 13.04 0 015.38 1.17l7.7-58.04a4.38 4.38 0 00-6.29-4.54l-24.97 19.02a4.38 4.38 0 01-6.38-.92L73.29 17.94a4.36 4.36 0 00-6.58 0L42.06 54a4.38 4.38 0 01-6.38.92L10.71 35.9a4.38 4.38 0 00-6.29 4.53l7.7 58.05a13.04 13.04 0 015.38-1.17z"
        strokeWidth="8.749995"
      />
      <path
        d="M122.5 97.3h-105a13.13 13.13 0 00-13.13 13.13h0a13.13 13.13 0 0013.13 13.13h105a13.13 13.13 0 0013.13-13.13h0a13.13 13.13 0 00-13.13-13.12z"
        strokeWidth="8.749995"
      />
    </g>
  </svg>
);
